// 新公告
<template>
  <div>
    <p style="text-align: center">
      <span class="systemFont0"
        >{{ groupName }} {{ $t("p0403.newAnnouncement") }}</span
      >
    </p>
    <div class="main">
      <!-- 主题 -->
      <div style="text-align: left; margin-bottom:2px;">
        {{ $t("p0403.emailTitle") }}
      </div>
      <el-form :model="announcement">
        <el-form-item>
          <el-input size="noticeInput" v-model="announcement.emailTitle"></el-input>
        </el-form-item>
      </el-form>
      <!-- 富文本框 -->
      <div>
        <div style="text-align: left; margin-top:1%;">
          {{ $t("p0403.body") }}
        </div>
        <editor v-model="yourContent" style="width: 100%"></editor>
      </div>
      <!-- 添加附件 -->
      <div style="height: 80px">
        <div style="text-align: left; margin-top: 1%">
          {{ $t("p0403.attachment") }}
        </div>
        <div style="border: 1px dashed #d7d7d7;">
          <uploadFile
            style="margin-left: 47%;"
            ref="uploadCardFile_1"
            :uploadButtonStyle="uploadButtonStyle"
            :uploadFile="{
              locationCode: locationCode,
              uploadBtnDisplayFlag: uploadBtnDisplayFlag
            }"
          >
          </uploadFile>
        </div>
      </div>
      <el-row class="foot-container">
        <!-- 发送 -->
        <el-button
          style="margin-bottom: 30px"
          type="submit"
          @click="sendAllNotice"
          >{{ $t("p0403.send") }}</el-button
        >

        <!-- 返回 -->
        <el-button type="return" @click="$router.go(-1)">{{
          $t("common.back")
        }}</el-button>
      </el-row>
    </div>
  </div>
</template>

<script>
import qs from "qs";
import uploadFile from "../../../components/Common/UploadAttachment.vue";
import Editor from "@/components/imcoder-tinymce";
import { build20Id } from "../../../utils/buildId.js";
export default {
  components: {
    Editor,
    uploadFile
  },
  data() {
    return {
      // 主题
      announcement: {
        emailTitle: ""
      },
      // 上传按钮控件是否显示按钮（重新加载用）
      uploadFileReloadFlag: true,
      // 上传按钮显示标志
      uploadBtnDisplayFlag: true,
      // 位置关联Code
      locationCode: build20Id(),
      uploadButtonStyle: 0,
      // 群名称
      groupName: "",
      // 富文本框
      yourContent: ""
    };
  },
  methods: {
    // 附件提交
    async upload() {
      // 风险分析1
      await this.$refs.uploadCardFile_1.submitUploadFile();
    },
    // 改变上传文件的状态
    changeUploadFileStatus() {
      // console.log(this.uploadFile.uploadBtnDisplayFlag) //= !this.uploadFile.uploadBtnDisplayFlag;
      this.uploadBtnDisplayFlag = !this.uploadBtnDisplayFlag;
      this.reloadUploadFile();
    },
    // 发送成功通知
    open() {
      this.$alert(this.$t("p0403.sendSuccess"), this.$t("common.tips"), {
        confirmButtonText: this.$t("common.confirm"),
        callback: action => {}
      });
    },
    // 警告通知
    warn(info) {
      this.$alert(info, this.$t("common.warning"), {
        confirmButtonText: this.$t("common.confirm"),
        callback: action => {}
      });
    },
    // 重新加载上传附件控件
    async reloadUploadFile() {
      this.uploadFileReloadFlag = false;
      await this.$nextTick();
      this.uploadFileReloadFlag = true;
    },
    // 发送通知
    async sendAllNotice() {
      // let url = "/api/emailGroupView/test";
      // this.$http
      //   .post(url)
      //   .then(response => {
      //     if (response.data.code === 200) {
      //       console.log("aaa");
      //     }
      //   })
      if (this.announcement.emailTitle.length == 0) {
        this.$message.error(this.$t("p0403.pleaseEnterEmailTitle"));
      } else {
        const loading = this.$loading({
          lock: true,
          text: this.$t("common.loading"),
          background: "rgba(255,255,255,0.8)",
          target: document.querySelector("#main-container")
        });
        await this.upload();
        if (this.$refs.uploadCardFile_1.uploadFileList.length == 0) {
          this.locationCode = null;
        }
        let params = {
          body: this.yourContent,
          locationCode: this.locationCode,
          emailTitle: this.announcement.emailTitle,
          loginId: localStorage.getItem("userId")
        };
        let url = "/api/emailGroupView/sendAllNotice";
        this.$http
          .post(url, params)
          .then(response => {
            loading.close();
            this.locationCode = build20Id();
            if (response.data.code === 200) {
              this.open();
            } else {
              loading.close();
              this.warn(response.data.message);
            }
          })
          .catch(err => {
            console.log(err);
            loading.close();
            this.$message.error(this.$t("common.anErrorOccurred"));
          });
      }
    }
  },
  mounted() {
    if (this.$route.query.groupName) {
      this.groupName = this.$route.query.groupName;
    }
  }
};
</script>

<style lang="scss" scoped>
.main {
  width: 80%;
  margin: 0 auto;
  padding-top: 17px;
  // display: flex;
}
>>> .el-form-item {
  margin-bottom: 0%;
  text-align: left;
}
.foot-container {
  margin: 40px auto 0 auto;
  height: 26px;
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/views/Marketing/EmailMarketing/P0406.vue